/* 
https://www.iconfinder.com/icons/1243689/call_phone_icon
Creative Commons (Attribution 3.0 Unported);
https://www.iconfinder.com/Makoto_msk */

export const storeProducts = [
  {
    id: 1,
    title: "Google Pixel XL - Black",
    img: "img/product-1.png",
    price: 50000,
    company: "GOOGLE",
    info: "The Google Pixel XL features a sleek design and high-performance specifications. It boasts a 5.5-inch AMOLED display with a resolution of 1440 x 2560 pixels, providing vibrant colors and sharp details. Powered by a Qualcomm Snapdragon 821 processor and 4GB of RAM, this smartphone delivers smooth multitasking and fast performance. The 12.3MP rear camera with f/2.0 aperture captures stunning photos even in low light, while the 8MP front camera is perfect for selfies and video calls. With 32GB of internal storage and a long-lasting 3450mAh battery, the Pixel XL ensures you have enough space for your apps, photos, and media while keeping you powered throughout the day. It runs on the latest Android operating system, offering a clean and intuitive user experience with timely updates.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 2,
    title: "Samsung S7",
    img: "img/product-2.png",
    price: 58000,
    company: "SAMSUNG",
    info: "The Samsung Galaxy S7 features a stunning 5.1-inch Super AMOLED display with a resolution of 1440 x 2560 pixels, offering vibrant colors and sharp clarity. It is powered by the Exynos 8890 Octa-core processor and 4GB of RAM, ensuring smooth performance and efficient multitasking. The S7's 12MP rear camera with f/1.7 aperture excels in low-light conditions and captures high-quality photos and videos, while the 5MP front camera is ideal for selfies and video calls. With 32GB of internal storage, expandable via microSD card, and a 3000mAh battery, the Galaxy S7 provides ample space for your media and apps while delivering long-lasting battery life. Running on Android, it offers a user-friendly experience with Samsung's TouchWiz UI and regular updates.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 3,
    title: "HTC 10 - Black",
    img: "img/product-3.png",
    price: 52000,
    company: "htc",
    info: "The HTC 10 boasts a sleek and premium design with a 5.2-inch Super LCD5 display, delivering a resolution of 1440 x 2560 pixels for sharp and vibrant visuals. Powered by the Qualcomm Snapdragon 820 processor and 4GB of RAM, it offers exceptional performance and multitasking capabilities. The 12MP rear camera features optical image stabilization and f/1.8 aperture, allowing for high-quality photos with excellent detail, while the 5MP front camera is perfect for selfies and video chats. With 32GB of internal storage and expandable memory via microSD, along with a 3000mAh battery, the HTC 10 ensures ample space for your media and long-lasting use throughout the day. It runs on Android with HTC's Sense UI, providing a clean and intuitive user experience.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 4,
    title: "HTC 10 - White",
    img: "img/product-4.png",
    price: 51000,
    company: "htc",
    info: "The HTC 10 boasts a sleek and premium design with a 5.2-inch Super LCD5 display, delivering a resolution of 1440 x 2560 pixels for sharp and vibrant visuals. Powered by the Qualcomm Snapdragon 820 processor and 4GB of RAM, it offers exceptional performance and multitasking capabilities. The 12MP rear camera features optical image stabilization and f/1.8 aperture, allowing for high-quality photos with excellent detail, while the 5MP front camera is perfect for selfies and video chats. With 32GB of internal storage and expandable memory via microSD, along with a 3000mAh battery, the HTC 10 ensures ample space for your media and long-lasting use throughout the day. It runs on Android with HTC's Sense UI, providing a clean and intuitive user experience.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 5,
    title: "HTC Desire 626s",
    img: "img/product-5.png",
    price: 24000,
    company: "htc",
    info: "The HTC Desire 626s offers a budget-friendly option with solid performance and design. It features a 5.0-inch HD display with a resolution of 720 x 1280 pixels, providing clear and vibrant visuals for everyday use. Powered by a Qualcomm Snapdragon 210 processor and 1GB of RAM, the Desire 626s handles basic tasks and light multitasking with ease. The 8MP rear camera captures decent photos and videos, while the 2MP front camera is suitable for selfies and video calls. With 16GB of internal storage, expandable via microSD, and a 2000mAh battery, the Desire 626s offers enough space for your essential apps and media, and reliable battery life for daily use. It runs on Android with HTC's Sense UI, delivering a user-friendly experience with useful features and customizations.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 6,
    title: "Iphone 4",
    img: "img/product-6.png",
    price: 13500,
    company: "apple",
    info: "The iPhone 4, released in 2010, features a 3.5-inch Retina display with a resolution of 640 x 960 pixels, offering sharp and vibrant visuals. It is powered by the Apple A4 processor and 512MB of RAM, which provides adequate performance for basic tasks and older apps. The 5MP rear camera with LED flash captures good-quality photos and 720p HD videos, while the front-facing VGA camera is suitable for video calls. With 8GB or 16GB of internal storage (depending on the model), users have ample space for apps and media, although it lacks expandable storage. The iPhone 4 comes with a 1420mAh battery, offering reasonable battery life for its time. Running on iOS 7, it delivers a smooth user experience with a range of apps and features.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 32000,
    company: "apple",
    info: "The iPhone 7 features a 4.7-inch Retina HD display with a resolution of 750 x 1334 pixels, providing bright and sharp visuals. Powered by the Apple A10 Fusion chip and 2GB of RAM, it offers significant performance improvements and efficiency for everyday tasks and gaming. The 12MP rear camera with optical image stabilization and f/1.8 aperture captures high-quality photos and 4K video, while the 7MP front camera is great for selfies and FaceTime. With storage options of 32GB, 128GB, or 256GB, users have plenty of space for apps, photos, and media. The iPhone 7 is equipped with a 1960mAh battery, delivering good battery life. It also introduces water and dust resistance with an IP67 rating, enhancing durability. Running on iOS, it provides a smooth and intuitive user experience with access to a wide range of apps and features.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 8,
    title: "Screen Broken Iphone 7",
    img: "img/product-8.png",
    price: 5000,
    company: "apple",
    info: "This iPhone 7 is being sold as-is with significant physical damage. It features a 4.7-inch Retina HD display, but the screen is cracked and may not be fully functional. Despite the damage, the phone is powered by the Apple A10 Fusion chip and offers the same performance capabilities as an undamaged iPhone 7. The rear 12MP camera and 7MP front camera may still work, but their functionality cannot be guaranteed due to the condition of the device. Storage options are available (32GB, 128GB, or 256GB), but the internal storage may have limitations or issues due to the physical damage. The device is priced accordingly to reflect its condition, and repairs or replacements may be required. This phone is suitable for those who are looking for a budget-friendly option for parts or repair projects.",
    inCart: false,
    count: 0,
    total: 0,
  },
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 10,
  company: "google",
  info: "Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.",
  inCart: false,
  count: 0,
  total: 0,
};
